module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAA0CAMAAAD7TUujAAAAQlBMVEVHcEwAoOs3PEUAouoAoesAoesAoesQkc0AoesAouw3O0U3O0QAoOo2O0X////j9PwEl9tJu/AiYYMOhb4oVW8ab5u7Zc8oAAAADHRSTlMATpJum7bZHfNros0f6xmqAAAA6UlEQVRIx+2WzQ6DIBCEF+U33VYUeP9XLWoF0mQrm5j04pznW2b3wgBkmeHxrIopeI+trFbOQNXQuJeAhGRBmunJIy0rvucvv+yrxi1/8Qc8lWgeiP7cj9aUDRbskgRg+RHNDsReP7od8N2Ags77HNLAWWC9E7ACZWUgIROgHpinV9E0V4DcoPFnogKBC5BpiUgReYLEBQIX8NcBxNL0LOKsFwLsSMTSN3ADfwMsz29B8wANigcocDzAgeEB+d+VHL9cqwDjTnYrKKIf+NSTsdc/HgVIdKU66s9WaTo2l20ny4hTmnynrXBvqyNx4ajJfKEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/home/projectManagement.png
// module id = 0JHJ
// module chunks = 20